import { get } from "lodash";
import { CONDITIONS } from "MODULES/Shipping/constants";
import { TRACE_TYPES } from "MODULES/inventories/constants";
import { truncate } from "LIB/formatters/text";
import { useSettings } from "APP_ROOT/hooks/useCurrentUser";
import { LABEL_SIZE } from "APP_ROOT/constants";

const noteFunc = (expiration, noteStr, large) => {
  if (!noteStr) return "";

  return `^FO${`${expiration ? "20" : "60"}`},${large
    ? "160"
    : "50"}^FDNotes: ${truncate(noteStr || "", large ? 80 : 15)}^FS`;
};

export const label = ({
  cage,
  company_name: companyName,
  condition,
  date_received: date,
  dom,
  expiration,
  location,
  notes,
  obtained_from: obtainedFrom,
  part_description: desc,
  part_number: partNumber,
  quantity,
  release_types: releaseTypes,
  serial_number: serialNumber,
  tag_date: tagDate,
  tagged_by: taggedBy,
  trace_type: traceType
}) => {
  const large = get(useSettings(), LABEL_SIZE, "4x6") === "4x6";
  return `
^XA
^FWR
^FX Top section with logo, name and address.
^CF0,60
^FO590,${large ? "160" : "50"}^FD${truncate(companyName, 20) || ""}^FS
^CF0,30

^CFA,25
^FO570,${large ? "160" : "50"}^FDDate Received: ${date || ""}^FS
^FO540,${large ? "160" : "50"}^FDPart #: ${partNumber}^FS
^FO500,${large ? "160" : "50"}^FDSN: ${serialNumber}^FS
^FO460,${large ? "160" : "50"}^FDDesc: ${desc || ""}^FS
^FO420,${large ? "160" : "50"}^FDRef #: ${obtainedFrom || ""}^FS
^FO380,${large ? "160" : "50"}^FDCD | QTY: ${CONDITIONS[condition].abbrev ||
    ""} | ${quantity || ""}^FS
^FO340,${large ? "160" : "50"}^FDTag Date: ${tagDate || ""}^FS
^FO300,${large ? "160" : "50"}^FDTrace Type: ${(traceType &&
    TRACE_TYPES[traceType].abbrev) ||
    ""}^FS
^FO260,${large ? "160" : "50"}^FDCage: ${cage || ""}^FS
^FO220,${large ? "160" : "50"}^FDDOM: ${dom || ""}^FS
^FO180,${large ? "160" : "50"}^FDLocation: ${location || ""}^FS
^FO140,${large ? "160" : "50"}^FDRelease Type: ${releaseTypes || ""}^FS
^FO100,${large ? "160" : "50"}^FDTagged By: ${truncate(
    taggedBy,
    large ? 80 : 15
  ) || ""}^FS
${expiration ? `^FO60,${large ? "160" : "50"}^FDExpires: ${expiration}^FS` : ""}
${noteFunc(expiration, notes, large)}
^XZ`;
};

export const print = textToPrint => {
  /* eslint-disable-next-line */
  BrowserPrint.getDefaultDevice("printer", device => {
    device.send(
      textToPrint,
      _success => {
        /* eslint-disable-next-line */
        console.log("Sent to printer");
      },
      error => {
        /* eslint-disable-next-line */
        console.error(`Error:${error}`);
      }
    );
  });
};



// WEBPACK FOOTER //
// ./app/lib/zebra/print.js